<template>
  <div>
    <div class="notice">
      <v-layout>
        <v-btn icon x-small class="mr-1">
          <v-img src="@/assets/images/icons/exclamation-circle.png" />
        </v-btn>
        <p class="font--m-5 mb-0 font-weight-bold color--nice-black">
          <span class="highlighter">모든 항목이 아니오</span>에 해당하는 경우에만 대출신청이
          가능하며, 하기 내용이 사실과 다를 경우 신청 대상에서 제외 되더라도 이의를 제기하지
          않습니다.
        </p>
      </v-layout>
    </div>

    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit">
        <div class="pt-4 px-3">
          <h1 class="font--m-3 mb-2">대출 제한 사유</h1>
          <SelfDiagnosisChartItem
            v-for="(item, index) in items"
            :key="index"
            :index="index + 1"
            :text="item.text"
            :subtexts="item.subtexts"
            :listStyle="item.listStyle"
            :radioValue.sync="item.radioValue"
          >
            <component v-if="item.component" :is="item.component" />
          </SelfDiagnosisChartItem>

          <Signature @sign="sign = $event" class="pb-8">
            <template v-slot:memorandum>
              <p class="text-center">상기 기재 내용이<br />사실과 다름이 없음을 확인합니다.</p>
            </template>
          </Signature>
        </div>

        <v-btn
          color="primary"
          height="52"
          type="submit"
          block
          tile
          class="font--m-3"
          :disabled="loading"
          :loading="loading"
        >
          제출
        </v-btn>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  props: ['loading'],
  components: {
    Signature: () => import('./Signature.vue'),
    SelfDiagnosisChartItem: () => import('./chart/SelfDiagnosisChartItem.vue'),
  },
  data() {
    return {
      sign: null,

      items: [
        {
          text: `
            우리동네 크라우드펀딩 대출신청과 관련하여 다음과 같이 정책목적을 위반하는
            행위는 ‘제3자 부당개입’으로 간주하여 대출신청제한, 지원결정 취소 등의 불이익
            처분을 받을 수 있음을 알려드립니다.
          `,
          subtexts: [
            `(금품, 향응 요구) 제3자가 부당하게 개입하여 대출알선 등 업무추진을 위해 공
              단에 사례를 해야 한다는 명목으로 금품 등을 요구하는 경우`,
            `(대출심사 허위 대응) 재무제표 분식, 사업계획 과대포장 등 허위로 신청서류를
              작성하고 수수료를 요구하는 경우`,
            `(허위 대출약속) 지원 자격이 안 되는 기업(요건미흡 등)을 대상으로 정책자금
              을 받아주겠다며 대가를 요구하는 경우`,
            `(부정청탁) 정부기관, 공단 직원 등과의 인적 네트워크를 통해 정책자금 지원이
              가능하도록 하겠다고 약속하고, 착수금 등을 요구하는 경우`,
            `(정부기관 등 사칭) 제3자가 정부 공무원이나 공공기관 직원의 명함을 임의로
              사용하거나 허위로 정책자금 관련 기관 직원을 사칭하는 경우`,
          ],
          radioValue: null,
        },
        {
          text: `
            상시근로자수가 5인 이상인 경우(제조, 건설, 운수, 광업은 10인 이상인 경우)
          `,
          subtexts: ['단 장애인기업확인서’ 보유자인 경우에는 상시근로자 확인하지 않음'],
          listStyle: "'*'",
          radioValue: null,
        },
        {
          text: `
            주된 업종의 연매출액이 소기업 규모기준을 초과하는 경우
          `,
          radioValue: null,
          component: () => import('./chart/SmallBusinessConditionsDialog.vue'),
        },
        {
          text: `
            신청기업 및 대표자(실제경영자 포함)가 국세 또는 지방세를 체납 중인 경우 (단, 징수유예 / 체납처분유예 / 징수특례의 경우 대출신청 가능)
          `,
          radioValue: null,
        },
        {
          text: `
          신청기업 및 대표자(실제경영자 포함)가 한국신용정보원의 “일반신용정보관리규약”에 따라 “신용도판단정보” 또는 “공공정보”에 해당하는 다음의 경우
          `,
          subtexts: [
            '(신용도 판단정보) 연체, 대위변제·대지급, 부도(어음 거래정지처분 등), 관련인, 금융질서문란 등',
            '(공공정보) 세금, 과태료 체납, 채무불이행자 등재, 신용회복지원, 회생·개인회생· 파산면책 결정, 산재·고용보험료·임금 체납, 국외이주신고에 대한 정보 등',
          ],
          radioValue: null,
        },
        {
          text: `
            신청기업 또는 대표자(실제경영자 포함)가 현재 공단 또는 금융기관 등에 연체금액을 보유 중이거나, 최근 3개월 이내에 계속하여 30일 이상 연체 또는 10일
            이상 연체가 4회 이상 발생한 사실이 있는 경우
          `,
          radioValue: null,
        },
        {
          text: `
            자가(임차)사업장 또는 대표자(실제경영자 포함)등 소유 거주주택에 대한 권리침해*사실이 있거나, 권리침해사실이 해제되었더라도 권리침해 해제 시점(등기접수
            일자 기준)이 3개월 이내인 경우
          `,
          subtexts: [
            '권리침해 : <자가>압류(경매 포함), 가압류, 가처분 등 / <임차>경매신청기입등기',
          ],
          listStyle: "'*'",
          radioValue: null,
        },
        {
          text: `
            휴·폐업 중인 경우
          `,
          radioValue: null,
        },
        {
          text: `
            공단에서 성공불융자 ‘고의실패’ 판정을 받은 업체 또는 해당업체의 대표자(대표이사)가 운영하는 기업(법인 포함)은 판정일로부터 향후 3년간 대출신청 제한
          `,
          radioValue: null,
        },
        {
          text: `
            소상공인 정책자금 지원제외업종에 해당하는 경우(세부 지원제외업종은 공고문 확인)
          `,
          radioValue: null,
        },
        {
          text: `
            실제 경영자가 사업자등록증상 대표자가 아닌자, 법인인 경우 실제 경영자가 다음 중 어느 하나에 해당하지 않는 경우
          `,
          subtexts: ['(공동)대표이사, 무한책임사원', '최대주주'],
          listStyle: 'decimal',
          radioValue: null,
        },
        {
          text: `
            기타 허위 또는 부정한 방법으로 융자를 신청한 사실이 있는 경우
          `,
          radioValue: null,
        },
      ],
    }
  },
  computed: {
    isValidRadioValues() {
      return this.items.every((e) => e.radioValue != null && e.radioValue === false)
    },
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.form.validate()
      if (!isValid || !this.isValidRadioValues) {
        await this.$swal.fire({
          html: `<p class="custom-alert__text">
            모든 항목에 체크해주세요.<br />
            모든 항목이 아니오에 해당하는 경우에만 신청이 가능합니다.
          </p>`,
          confirmButtonText: '확인',
          customClass: { container: 'custom-alert2', actions: 'single' },
        })
        return
      }

      if (!this.sign) {
        await this.$swal.fire({
          html: `<p class="custom-alert__text">
            사인을 해주세요.
          </p>`,
          confirmButtonText: '확인',
          customClass: { container: 'custom-alert2', actions: 'single' },
        })
        return
      }

      this.$emit('success')
    },
  },
}
</script>

<style lang="scss" scoped>
.notice {
  background-color: #f4faff;
  padding: 16px 12px;

  .highlighter {
    background-color: #fe8100;
    color: white;
    padding: 1px;
  }
}
</style>
